module.exports = {"211002001":"星火街道","211002002":"胜利街道","211002003":"跃进街道","211002005":"卫国路街道","211002006":"站前街道","211002010":"武圣街道","211002011":"襄平街道","211002012":"文圣街道","211002013":"南门街道","211002014":"东兴街道","211002015":"新华街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/211002.json
// module id = 571
// module chunks = 0